import { useState, useEffect } from 'react'

// Noted: Tempory hook before moving to `FlagSmith`
export default function usePomeloCreditEnable(currentShopId) {
  const [isLoading, setLoading] = useState(true)
  const [isCreditEnabled, setIsCreditEnabled] = useState(true)

  useEffect(() => {
    import('lib/firebase/index')
      .then(({ remoteConfig }) =>
        remoteConfig.fetchAndActivate().then(() => {
          const enabledStoreIDs = JSON.parse(
            // eslint-disable-next-line no-underscore-dangle
            remoteConfig.getValue('PMLCreditVisibility_20231101')._value,
          )
          setIsCreditEnabled(enabledStoreIDs.includes(currentShopId))
        }),
      )
      .catch(() => {
        setIsCreditEnabled(true)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [currentShopId])

  return isLoading ? false : isCreditEnabled
}
